import { render, staticRenderFns } from "./SalesPaymentReview.vue?vue&type=template&id=696831fa&"
import script from "./SalesPaymentReview.vue?vue&type=script&lang=js&"
export * from "./SalesPaymentReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports